import styled from '@emotion/styled/macro'
import mediaQuery from 'share/utils/mediaQuery'

import { pageContentDefaultSize } from 'style/emotion'

const QuestionnaireSectionSummaryContainer = styled('section')`
  ${pageContentDefaultSize}

  .attorney-comment-card {
    margin-top: 48px;
    margin-bottom: -24px;
    .attorney-comment-header {
      padding: 8px;
      color: #173237;
      font-size: 14px;
      font-weight: 500;
      background: #fdf7e9;
      border: 1px solid #8d6613;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
    .attorney-comment-container {
      display: flex;
      padding: 8px;
      color: #173237;
      font-weight: 400;
      border-left: 1px solid #8d6613;
      border-bottom: 1px solid #8d6613;
      border-right: 1px solid #8d6613;
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;

      .attorney-image {
        .mdi.mdi-account-circle {
          &::before {
            font-size: 1.5rem;
            line-height: 1.5rem;
          }
        }
        margin-right: 8px;
        & > img {
          height: 1.5rem;
          width: 1.5rem;
          border-radius: 50%;
        }
      }
      .attorney-name {
        font-size: 14px;
      }
      .attorney-comment {
        font-size: 12px;
        margin-top: 8px;
        white-space: pre-line;
      }
    }

    ${mediaQuery('tablet')} {
      margin-top: 24px;
      margin-bottom: 0px;
    }
  }

  .summary-header {
    line-height: 28px;
    margin-top: 48px;
    margin-bottom: 1rem !important;
    ${mediaQuery('tablet')} {
      margin-top: 24px;
    }
  }

  .summary-description {
    white-space: pre-line;
    font-size: 14px;
    font-weight: 400;
    color: #173237;
  }
  .accordion {
    .card {
      .card-body {
        background-color: #fff !important;
      }
    }

    margin-bottom: 24px;
    margin-top: 48px;

    ${mediaQuery('tablet')} {
      margin-top: 24px;
    }
  }

  .btn-container {
    display: flex;
    margin-top: 2.5rem;
    width: 100%;
    ${mediaQuery('tablet')} {
      margin-top: 2rem;
    }
    .btn {
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      ${mediaQuery('', 'tablet')} {
        width: 50%;
      }
      @media only screen and (min-width: 1920px) {
        width: 50%;
      }
    }
  }
  .save-finish-later-link {
    text-align: center;
    margin-top: 28px;
  }
  .questionnaire-summary-important {
    margin-top: 2.75rem;
    color: #748487;
    font-size: 14px;
    font-weight: 500;
    ${mediaQuery('desktop', 'tablet')} {
      margin-top: 3.25rem;
    }
  }
  .questionnaire-summary-important-text {
    color: #173237;
    font-size: 12px;
    font-weight: 400;
  }
`

const QuestionnaireSectionSummaryCardWrapper = styled('div')`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  width: inherit;

  section {
    ${mediaQuery('', 'tablet')} {
      &:nth-of-type(even) {
        margin-left: 1rem;
      }
    }
    ${mediaQuery('tablet')} {
      width: 100%;
    }
  }

  .summary-card {
    border-radius: 3px;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: 1rem;
    padding-top: 0.8rem;
    margin-top: 16px;
    border: 1px solid #d1d6d7;
    display: flex;
    border-radius: 3px;
    flex-basis: 100%;
    ${mediaQuery('', 'tablet')} {
      height: 95px;
    }
  }
`

const QuestionnaireSectionSummaryReadOnlyNotification = styled('section')`
  width: 100%;
  margin-top: 48px;
  font-size: 14px;
  font-weight: 400;
  color: var(--CINight);
  display: flex;
  white-space: pre-line;

  ${mediaQuery('tablet')} {
    margin-top: 24px;
  }

  > div {
    background-color: #eaf2f8;
    padding: 8px;
    border: 1px solid #2a7ab7;
    width: 100%;
  }

  .blue-info-icon {
    color: var(--skydiver);
    fontsize: 16px;
  }

  @media (min-width: 769px) {
    margin-bottom: -24px;
  }
`

export {
  QuestionnaireSectionSummaryContainer,
  QuestionnaireSectionSummaryCardWrapper,
  QuestionnaireSectionSummaryReadOnlyNotification
}
